<script>
    import OPTS from '../options';
    import {fade} from 'svelte/transition';
    import {getContext} from 'svelte';
    import {query, current_result} from '../stores';
    import RefineSearchField from "./RefineSearchField.svelte";
    import Pagination from './Pagination.svelte';
    import TextExpand from './TextExpand.svelte'
    import ThumbView from "./ThumbView.svelte";
    import ListView from "./ListView.svelte";

    export let tab_id;
    export let type; // thumb | list
    export let label;
    export let text = '';
    export let root_id = '';

    const view = type === 'thumb' ? ThumbView : ListView;

    let tabs = getContext('tabs');
    $tabs = [...$tabs, {tab_id, label}]

    $: results = tab_id === $query.active ? $current_result.docs : [];

    function openHierTree() {
        window.openTreeModal(root_id);
    }
</script>

<style>
    .hier-container {
        margin-top: 20px;
    }
</style>

<div class="tab-pane " class:active={tab_id === $query.active} role="tabpanel">
    <div class="row">
        <div class="col-12 col-md-9 content-text">
            <TextExpand {text} max={2000} />

            <!-- apertura albero gerarchico solo se in modalità singolo archivio a lista e non sulla tab generale -->
            {#if OPTS.mode_single && type === 'list' && tab_id !== 'all'}
                <div class="hier-container">
                    <button on:click|preventDefault={openHierTree} type="button" class="btn btn-primary">vai alla gerarchia</button>
                </div>
            {/if}
        </div>

    </div>

    {#if $query.active === tab_id}
    <div in:fade={{ duration: 400 }} class="row">
        <div class="col-12 col-md-9 " class:wrap-esito-thumb={type === 'thumb'}>
            <svelte:component this={view} {results} />

            <Pagination total={$current_result.total} show="9" current_page={$query.current_page} on:change-page={ e => query.setPage(e.detail.page)} />
        </div>

        <div class="col-12 col-md-3 sidebar">
            <RefineSearchField />

            <div class="wrap-filter">
                <slot />
            </div>
        </div>
    </div>
    {/if}
</div>
